import { memo, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Checkbox, Radio, RadioGroup, TextField } from 'basic-components';
import { CommonService } from 'dashboard-services/services';

const MINUTLY = {
  EXACTLY_AT: "EXACTLY_AT",
  EVERY_X_MINUTES: "EVERY_X_MINUTES"
}

const getSelectedMinutly = hour => {
  if(String(hour).indexOf("/") > -1) {
    return MINUTLY.EVERY_X_MINUTES;
  } else {
    return MINUTLY.EXACTLY_AT;
  }
}

const getEveryMinute = minute => {
  if(String(minute).startsWith("0/")) {
    return String(minute).slice(2)
  }
  return ""
}

const Minute = ({ minute = "", setMinute }) => {
  const [selectedMinutly, setSelectedMinutly] = useState(() => getSelectedMinutly(minute)),
        onChangeExactMinute = useCallback(selected => {
          const splittedMinute = minute === "*" || minute === "" || minute.indexOf("/") > -1 ? [] : String(minute).split(",")
          if(splittedMinute.indexOf(String(selected)) > -1) {
            setMinute(splittedMinute.remove(splittedMinute.indexOf(String(selected))).join(","))
          } else {
            setMinute(splittedMinute.add(selected).join(","))
          }
        }, [minute, setMinute]),
        onChangeSelectedMinutly = useCallback(value => value && setSelectedMinutly(value), []),
        onChangeEveryXMinutes = useCallback(value => value !== "" && CommonService.isNumber(value) && setMinute(`0/${value}`), [setMinute])

  useEffect(() => {
    setSelectedMinutly(getSelectedMinutly(minute))
  }, [minute])

  return (
    <div className="cron-creator__body__minute">
      <RadioGroup
          name="minutly"
          onChange={onChangeSelectedMinutly}
          selectedValue={selectedMinutly}
      >
        <Radio name={MINUTLY.EXACTLY_AT}>
          Exactly at
        </Radio>
        <div className="cron-creator__body__at">
          {[...Array(60).keys()].map(index => (
            <Checkbox
                checked={String(minute).split(",").includes(String(index))}
                data-key={index}
                key={index}
                onChange={() => onChangeExactMinute(index)}
            >
              {('0' + String(index)).slice(-2)}
            </Checkbox>
          ))}
        </div>
        <Radio name={MINUTLY.EVERY_X_MINUTES}>
          <div className="cron-creator__body__every-x">
            <p>Every</p>
            <TextField
                defaultValue={getEveryMinute(minute)}
                name="everyXMinute"
                noError
                onChange={onChangeEveryXMinutes}
                variant="border"
            />
            <p>minutes</p>
          </div>
        </Radio>
      </RadioGroup>
    </div>
  )
}

Minute.propTypes = {
  minute: PropTypes.string,
  setMinute: PropTypes.func.isRequired
}

export default memo(Minute);